import { Controller } from "stimulus"
import GLightbox from "glightbox"
import "glightbox/dist/css/glightbox.min.css"

export default class extends Controller {
  connect() {
    this.downloadButton = this.element.querySelector('[data-action="external-auction#download"]')
    this.photosElement = this.element.querySelector('[data-external-auction-target="photos"]')
    this.photos = JSON.parse(this.element.dataset.externalAuctionPhotosValue)
    this.downloadUrl = this.element.dataset.externalAuctionDownloadUrlValue

    this.downloadButton.hidden = false
    this.renderPhotos()
  }

  disconnect() {
    if (this.lightbox) this.lightbox.destroy()
  }

  download() {
    if (!window.confirm("Czy na pewno chcesz pobrać wszystkie zdjęcia?")) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const form = document.createElement("form")
    const token = document.createElement("input")

    this.downloadButton.disabled = true
    form.action = this.downloadUrl
    form.method = "post"
    form.target = "_blank"
    token.name = "authenticity_token"
    token.type = "hidden"
    token.value = csrfToken

    form.appendChild(token)
    document.body.appendChild(form)
    form.submit()
    form.remove()
  }

  renderPhotos() {
    const photosByFolder = this.photos.reduce((folders, photo) => {
      if (photo.thumbnail_url && photo.original_url) {
        folders[photo.folder] = folders[photo.folder] || []
        folders[photo.folder].push(photo)
      }
      return folders
    }, {})
    const uniqueClass = `external-auction-glightbox-${Math.random().toString(36).slice(2)}`

    Object.entries(photosByFolder).forEach(([folder, photos]) => {
      const heading = document.createElement("h3")
      const row = document.createElement("div")

      heading.className = "mt-4"
      heading.textContent = folder
      row.className = "row"

      photos.forEach((photo, index) => {
        const link = document.createElement("a")
        const image = document.createElement("img")

        link.href = photo.original_url
        link.className = `${uniqueClass} d-block col-12 col-md-3`
        image.src = photo.thumbnail_url
        image.alt = `Zdjęcie ${index + 1}`
        image.className = "img-thumbnail"

        link.appendChild(image)
        row.appendChild(link)
      })

      this.photosElement.appendChild(heading)
      this.photosElement.appendChild(row)
    })

    this.lightbox = GLightbox({ selector: `.${uniqueClass}` })
  }
}
